<template>
  <div class="pdxtfb-warp">
    <SvgPanZoom
      style="width: 100%; height: 100%;"
      :zoomEnabled="true"
      :controlIconsEnabled="false"
      :fit="false"
      :center="false"
      :minZoom="0.5"
      @svgpanzoom="registerSvgPanZoom"
      id="svgbox"
    >
      <svg class="svgClass" aria-hidden="true">
        <use xlink:href="#icon-ele" />
      </svg>
    </SvgPanZoom>
    <div class="legend">
      <div class="cl">
        <div class="rectangle bg-402F78"></div>
        <label style="color:#000"
          >该颜色表示实际计量点，直接通过计量表计读取数据</label
        >
      </div>
      <div class="cl">
        <div class="rectangle bg-007947"></div>
        <label style="color:#000">该颜色表示虚拟计量点，直接计算获取数据</label>
      </div>
    </div>
  </div>
</template>
<script>
import SvgPanZoom from "vue-svg-pan-zoom";
import * as utils from "@/utils/index.js";
import "@/assets/svg/ele.svg";
import socket from "@/utils/websocket.js"; // 引用websocket
export default {
  components: {
    SvgPanZoom,
  },
  data() {
    return {
      wintitle: "详细信息",
      winalarm: false,
      TomeasureId: "",
      timer: null,
      sxtfbtViewId: "",
      pointCode: "",
      landscape: [],
      jsonData: {},
      viewNodes: [],
      webSock: {
        ip: "",
        port: "",
        key: "",
        path: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    let vm = this;
    vm.timer = setInterval(vm.init, 30 * 1000);
    let doms = document.querySelectorAll("g");
    for (let index = 0; index < doms.length; index++) {
      const domItem = doms[index];
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    formClose() {
      this.bus.$emit("formClose", "clear");
    },
    init() {
      let vm = this;
      let fid = "0";
      let pointCode = "229";
      let special = [];
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(0, "/zxjc/pdxtfbt", null)
        .then((res) => {
          if (!res) {
            return;
          }
          fid = utils.findDataByParam("pdxtfbtView", false, res.data);
          pointCode = utils.findDataByParam("pointCode", false, res.data);
          special =
            utils.findDataByParam("special", false, res.data) == ""
              ? []
              : JSON.parse(res.data["special"]);
          //获取视图的树数据
          vm.$api.view.getViewTreeNodes(fid).then((res) => {
            let viewNodes = [];
            let measures = [];
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              let measuresItem = {};
              let specialItem = special.find((obj) => {
                return obj.id == data[i].measureId;
              });
              measuresItem.measureId = item.measureId;
              if (specialItem) {
                measuresItem.pointNumber = specialItem.pointNumber;
                measuresItem.pointCode = specialItem.pointCode;
              } else {
                measuresItem.pointNumber = 0;
                measuresItem.pointCode = pointCode;
              }
              measures.push(measuresItem);
              viewNodes.push(item);
            }
            vm.viewNodes = viewNodes;
            vm.$api.quantity
              .getQuantityDay3(
                measures,
                utils.formatDate(new Date(), "yyyy-MM-dd") + " 00:00:00",
                utils.formatDate(new Date(), "yyyy-MM-dd") + " 23:59:59",
                null
              )
              .then((res) => {
                if (!res) {
                  return;
                }
                vm.bindData(res.data);
              });
          });
        });
    },
    clickNode: function(node) {
      this.$router.push({
        path: "/yxfx/dqyxfx-new",
        query: { id: node.measureId, vid: 0 },
      });
    },
    bindData(data) {
      let vm = this;
      for (let i = 0; i < data.length; i++) {
        let item = vm.viewNodes.find((obj) => {
          return obj.measureId == data[i].measureId;
        });

        if (item) {
          item.value = data[i].data[0][0]
            ? data[i].data[0][0].value.toFixed(2)
            : "-";
        }
        console.log(item);

        var doms = document.querySelectorAll(
          "[measureId='" + item.measureId + "']"
        );
        if (doms.length > 0)
          for (var index = 0; index < doms.length; index++) {
            let domItem = doms[index];
            domItem.innerHTML = item.value;
          }
      }
    },
  },
};
</script>
<style scoped>
.pdxtfb-warp {
  width: 100%;
  height: 100%;
}
.svgClass {
  width: 100%;
  height: 100%;
}
.legend {
  display: flex;
  flex-flow: column;
  font-size: 14px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.cl {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.rectangle {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.bg-402F78 {
  background: #402f78;
}
.bg-007947 {
  background: #007947;
}
.bg-EC6901 {
  background: #ec6901;
}
</style>
